














import {
  computed,
  defineComponent, PropType,
} from '@nuxtjs/composition-api';

import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs.vue';
import useStructuredData from '~/composables/useStructuredData';
import { APP_ROUTER_PATHS } from '~/constants';
import { getTitle } from '~/helpers/brandTooltipHelpers';
import { isPrinter } from '~/helpers/productHelpers';
import { getBreadcrumbs } from '~/modules/catalog/product/getters/productGetters';
import { ProductInterface } from '~/modules/GraphQL/types';

export default defineComponent({
  name: 'ProductBreadcrumbs',
  components: { Breadcrumbs },
  props: {
    product: {
      type: [Object, null] as PropType<ProductInterface | null>,
      default: null,
    },
  },

  setup(props) {
    const { collectBreadcrumbsJsonLd } = useStructuredData();

    const brand = computed(() => getTitle(props.product));
    const fullBreadcrumbs = computed(() => {
      if (isPrinter(props.product)) {
        return [{ text: 'Printers', link: APP_ROUTER_PATHS.printers }];
      }

      const categories = props.product?.categories ?? [];
      const currentCategory = categories.find((category) => {
        const breadcrumb = category.breadcrumbs?.length > 1 ? category.breadcrumbs[category.breadcrumbs.length - 1] : category.breadcrumbs?.[0];

        return breadcrumb?.category_name === brand.value;
      });
      const productCategories = Array.isArray(categories) ? [...categories].pop() : null;

      return getBreadcrumbs(props.product, currentCategory || productCategories);
    });

    const breadcrumbs = computed(() => fullBreadcrumbs.value.slice(0, 2).map((breadcrumb) => ({
      text: breadcrumb.text,
      link: breadcrumb.link,
    })));

    const jsonLd = computed(() => collectBreadcrumbsJsonLd(fullBreadcrumbs.value, '', !!props.product));

    return {
      breadcrumbs,
      jsonLd,
    };
  },
});

